module.exports = __webpack_public_path__ + "img/concept.30028ceb.svg";